import { inject, Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { baseUrl } from "../../../../../../core/constants/base-url";
import { Observable, switchMap } from "rxjs";
import {
  AttachDetachProductsBodyParams,
  AttachDetachProductsParams,
  GetProductsQueryParams,
  WildberriesProductCardData
} from "../types/product-card-group-modal.types";
import { wildberriesProductCardsResourceType } from "../configs/product-card-group-modal-config";

@Injectable({
  providedIn: 'root'
})
export class ProductCardGroupModalApiService {
  private http = inject(HttpClient);
  private url = `${baseUrl}/${wildberriesProductCardsResourceType.path}/product-group`;

  public fetchUnattachedProducts(params: GetProductsQueryParams): Observable<Array<WildberriesProductCardData>> {
    return this.http.get<Array<WildberriesProductCardData>>(`${this.url}/unattached-products`, {
      params: params
    });
  }

  public fetchAttachedProducts(mainArticleId: number): Observable<Array<WildberriesProductCardData>> {
    return this.http.get<Array<WildberriesProductCardData>>(`${this.url}/attached-products`, {
      params: {
        mainArticleId: mainArticleId
      }
    });
  }

  public attachProducts({ body, queryParams }: AttachDetachProductsParams): Observable<Array<WildberriesProductCardData>> {
    return this.http.post<Array<WildberriesProductCardData>>(`${this.url}/attach`, body).pipe(
      switchMap(() =>
        this.fetchUnattachedProducts(queryParams)
      )
    );
  }

  public detachProducts(params: AttachDetachProductsBodyParams): Observable<Array<WildberriesProductCardData>> {
    return this.http.delete<Array<WildberriesProductCardData>>(`${this.url}/detach`, { body: params }).pipe(
      switchMap(() =>
        this.fetchAttachedProducts(params.mainArticleId)
      )
    );
  }
}
